const Permissions = "permissions";

/**
 * @description get permissions form localStorage
 */
export const getPermissions = () => {
  const permissions = window.localStorage.getItem(Permissions);
  return permissions ? JSON.parse(permissions) : [];
};

/**
 * @description save permissions into localStorage
 * @param permissions: []
 */
export const savePermissions = (permissions): void => {
  window.localStorage.setItem(Permissions, JSON.stringify(permissions));
};

/**
 * @description remove permissions form localStorage
 */
export const destroyPermissions = (): void => {
  window.localStorage.removeItem(Permissions);
};

export default { getPermissions, savePermissions, destroyPermissions };
